import React, { useState } from 'react';

import { useConfig } from '../../defaultConfig';
import useEFakturaAccount from '../../hooks/useEFakturaAccount';
import useTranslation, { format } from '../../hooks/useTranslation';
import { settingsTrackIDs } from '../../utils/gtm/trackIDs/settings';
import ButtonLinkItem from '../ButtonLinkItem/ButtonLinkItem';
import EFakturaAccountModal from './EFakturaAccountModal';

const EFakturaAccountButton = () => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    const [openEFakturaAccount, setOpenEFakturaAccount] = useState(false);
    const eFakturaAccount = useEFakturaAccount();
    const eFakturaAccountDescription = eFakturaAccount
        ? format(translated.eFakturaAccount.chosenEFakturaAccount, eFakturaAccount.alias)
        : undefined;
    if (!featureToggles.enableEFakturaAccount) return <></>;

    return (
        <>
            {featureToggles.enableEFakturaAccount && (
                <ButtonLinkItem
                    onClick={() => {
                        setOpenEFakturaAccount(true);
                    }}
                    description={eFakturaAccountDescription}
                    data-track-id={settingsTrackIDs.efakturaLink}
                    data-track-linkname={translated.eFakturaAccount.label}
                >
                    {translated.eFakturaAccount.label}
                </ButtonLinkItem>
            )}

            <EFakturaAccountModal open={openEFakturaAccount} setOpen={setOpenEFakturaAccount} />
        </>
    );
};

export default EFakturaAccountButton;
